import { useEffect, useRef, useState } from 'react';
var instanceCount = 0;
export function usePortalNode(portalName, portalClassName) {
    if (portalName === void 0) { portalName = 'popover'; }
    if (portalClassName === void 0) { portalClassName = ''; }
    var uniquePortalName = useRef("".concat(portalName, "-portal-").concat(instanceCount++));
    var _a = useState(null), portalContainer = _a[0], setPortalContainer = _a[1];
    useEffect(function () {
        var root = document.getElementById(uniquePortalName.current);
        if (!root) {
            root = document.createElement('div');
            root.id = uniquePortalName.current;
            root.className = portalClassName;
            document.body.appendChild(root);
        }
        setPortalContainer(root);
        return function () {
            if (root) {
                setPortalContainer(null);
                root.remove();
            }
        };
    }, [portalClassName]);
    return portalContainer;
}
//# sourceMappingURL=usePortalNode.js.map